module.exports = __webpack_public_path__ + "img/pic-4.29d73b85.png";